/**
 * 포트폴리오 갤러리 연도 정렬 (최신 연도 우선, Coming soon은 항상 맨 뒤)
 * @param {string | undefined} year
 */
export function parsePortfolioYear(year) {
    if (!year) return 0
    const match = String(year).match(/\d{4}/)
    return match ? Number(match[0], 10) : 0
}

/**
 * @template {{ year?: string, comingSoon?: boolean, title?: string }} T
 * @param {T[]} items
 * @returns {T[]}
 */
export function sortPortfolioByYear(items) {
    return [...items].sort((a, b) => {
        if (a.comingSoon && !b.comingSoon) return 1
        if (!a.comingSoon && b.comingSoon) return -1
        if (a.comingSoon && b.comingSoon) {
            return (a.title ?? '').localeCompare(b.title ?? '', 'ko')
        }

        const yearDiff = parsePortfolioYear(b.year) - parsePortfolioYear(a.year)
        if (yearDiff !== 0) return yearDiff

        return (a.title ?? '').localeCompare(b.title ?? '', 'ko')
    })
}
